exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toast__inner-wrapper{display:block;width:308px;margin-bottom:8px;padding:16px 16px 18px 20px;border-radius:8px;-webkit-box-shadow:0 8px 16px -4px rgba(51,51,51,.2);box-shadow:0 8px 16px -4px rgba(51,51,51,.2);border:solid 1px #ededed;background-color:#fff}@media(min-width: 1160px){.toast__inner-wrapper{margin-bottom:0}}.toast__inner-content{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.toast__inner-content svg{display:block;-ms-flex-negative:0;flex-shrink:0;margin-top:4px;margin-right:12px}.toast__simple-text{display:block;-ms-flex-positive:1;flex-grow:1;font-size:16px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.5;letter-spacing:normal;color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/components/toast/styles.scss
// module id = 1335
// module chunks = 57